import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8207 6.58928C18.8207 6.58928 18.6449 5.41294 18.1035 4.89642C17.418 4.21661 16.6516 4.21327 16.3 4.17329C13.7828 4 10.0035 4 10.0035 4H9.99648C9.99648 4 6.21719 4 3.7 4.17329C3.34844 4.21327 2.58203 4.21661 1.89648 4.89642C1.35508 5.41294 1.18281 6.58928 1.18281 6.58928C1.18281 6.58928 1 7.97223 1 9.35185V10.6448C1 12.0244 1.1793 13.4074 1.1793 13.4074C1.1793 13.4074 1.35508 14.5837 1.89297 15.1003C2.57852 15.7801 3.47852 15.7567 3.8793 15.83C5.3207 15.96 10 16 10 16C10 16 13.7828 15.9933 16.3 15.8234C16.6516 15.7834 17.418 15.7801 18.1035 15.1003C18.6449 14.5837 18.8207 13.4074 18.8207 13.4074C18.8207 13.4074 19 12.0278 19 10.6448V9.35185C19 7.97223 18.8207 6.58928 18.8207 6.58928ZM8.14023 12.2144V7.41905L13.0023 9.82505L8.14023 12.2144Z"
      fill="#24275B"
    />
  </svg>
);
